import { SummaryEventRowProps } from '@sport1/news-styleguide/Types'

const getGoals = (events: SummaryEventRowProps[]): SummaryEventRowProps[] =>
    events.filter(
        event =>
            event.awayIconType === 'GOAL' ||
            event.homeIconType === 'GOAL' ||
            event.awayIconType === 'PENALTY_SCORED' ||
            event.awayIconType === 'PENALTY_MISSED' ||
            event.homeIconType === 'PENALTY_SCORED' ||
            event.homeIconType === 'PENALTY_MISSED'
    )

export default getGoals
